import { imagePaths } from './imagePaths';

export const weddingConfig = {
  page: {
    title: "#MauGotHerAMan",
    favicon: "/logo.png"
  },

  couple: {
    name1: "Mahima",
    name2: "Aman",
  },

  resort: {
    name: "ITC Fortune Resort, Benaulim, Goa",
    address: "1795/H, Calwaddo, Benaulim, Salcete, Goa 403716",
    addressShort: "Calwaddo, Benaulim, Salcete, South Goa",
    pinCode: "403716",
    phone: "+91 832 672 3333",
    gpsCoordinates: {
      latitude: "15.246234462545777° N",
      longitude: "73.93020794477609° E"
    }
  },

  date: {
    ceremony: {
      date: "July 8 - July 9, 2026",
      time: "4:00 PM"
    },
    rsvpDatePicker: {
      minDate: { year: 2026, month: 6, day: 6 },
      maxDate: { year: 2026, month: 6, day: 9 }
    }
  },

  transportation: {
    airport: {
      name: "Goa International Airport (GOI)",
      description: "Dabolim Airport is the nearest airport, approximately 25 km from the venue.",
      travelTime: "30-35 minutes by taxi",
      distance: "25 km"
    },
    train: {
      primary: {
        name: "Madgaon Railway Station (MAO)",
        description: "The nearest major railway station, approximately 7 km from the venue.",
        travelTime: "15-20 minutes by taxi",
        distance: "7 km"
      },
      secondary: {
        name: "Vasco da Gama Railway Station (VSG)",
        description: "Another option, approximately 30 km from the venue.",
        distance: "30 km"
      }
    },
    road: {
      fromMumbai: { distance: "600 km", time: "10-12 hours drive" },
      fromPune: { distance: "450 km", time: "8-9 hours drive" },
      fromBangalore: { distance: "560 km", time: "10-11 hours drive" },
      highway: "NH66 (National Highway 66)"
    }
  },

  design: {
    colors: {
      primary: "#3A2512",
      secondary: "#3A2512",
      accent: "#F4C430",
      background: "#FFF8DC",
      overlay: "rgba(244, 196, 48, 0.3)",
      gold: "#FFB800",
      turmeric: "#F4C430",
      orange: "#FF6B35",
      headerColour: "#efe7e2",
      footerColour: "#d4d4b0",
      darkContrast: "#4A3420",
      success: "#28a745",
      successBackground: "#d4edda",
      successBorder: "#c3e6cb",
      white: "#ffffff"
    },
    backgroundOpacity: 0.45, // Opacity for non-hero sections (0-1)
    fonts: {
      heading: "'Playfair Display', serif",
      body: "'Lato', sans-serif",
      script: "'Dancing Script', cursive"
    },
    images: {
      heroMobile: imagePaths.heroMobile,
      heroDesktop: imagePaths.heroDesktop,
      heroMobilePosition: imagePaths.heroMobilePosition,
      heroTextPosition: imagePaths.heroTextPosition,
      couple: imagePaths.couple,
      venue: imagePaths.venue,
      background: imagePaths.background,
      backgroundBlur: imagePaths.backgroundBlur
    },
    confetti: {
      colors: ['#d4af37', '#f4d03f', '#f7dc6f', '#f9e79f', '#ffffff', '#e8e8e8'],
      particleCount: {
        single: 100,
        couple: 400
      },
      spread: {
        single: 70,
        couple: 100
      },
      originY: 0.6
    }
  },

  content: {
    hero: {
      title: "We're Getting Married!",
      subtitle: "Join us as we celebrate our special day"
    },

    story: {
      enabled: true,
      title: "Our Story",
      images: [
        { id: 'story1', filename: 'story1.jpeg' },
        { id: 'story2', filename: 'story2.jpeg' },
        { id: 'story3', filename: 'story3.jpeg' },
        { id: 'story4', filename: 'story4.jpeg' },
        { id: 'story5', filename: 'story5.jpeg' },
        { id: 'story6', filename: 'story6.jpeg' },
      ],
      text: `The story begins on 14th May 2023 in a cozy little chai spot in Sydney, Australia. We got to talking and didn't realise where the time flew by until the owner politely informed us that the place was closing soon. That has been the theme for us, time flying by in each other's company and years feeling like days.

From that first conversation, we found ourselves exploring Sydney together, chasing sunsets in new cities, getting lost in unfamiliar streets, and creating memories in every corner we discovered. Whether it was a spontaneous road trip or a planned adventure, every journey became more magical because we were experiencing it together.

Through all our travels, lazy mornings, and late-night conversations, we realized something beautiful: it didn't take long before we could picture ourselves growing old together. The thought of sharing countless more sunsets, exploring new places, and a lifetime of adventures felt inevitable.

And here we are, ready to make it official. Our journey has just begun and we can't wait to share one of it's biggest moments with all of you!`
    },

    schedule: {
      enabled: true,
      eventDescriptions: {
        haldi: '🌼 A little haldi (turmeric), a lot of love and endless smiles to kick off our wedding festivities. Lunch to follow!',
        sagaiSangeet: '💍 Where two hearts officially say Yes! (again 🤭). Rings first, dance floor later (Non negotiable 🕺💃🪩)',
        mayra: '🌺 A sweet celebration showering the bride with blessings and joy',
        sajjangot: '🍛👑 Where royal hospitality meets serious appetite.',
        baraatVarmala: '💒 The loud entrance, the big moment and the sacred circle'
      },
      days: [
        {
          date: "Wednesday, July 8, 2026",
          events: [
            {
              time: "11:00 AM",
              title: "Haldi",
              nickname: "Turmeric Turbulence",
              slug: "haldi",
              definition: "A little haldi (turmeric), a lot of love and endless smiles to kick off our wedding festivities!\n\nJoin us as family and friends come together to celebrate this beautiful pre wedding tradition where haldi is applied to bride and groom for blessings, purity and a natural glow.",
              dressCode: "Indian / Indo Western attire in orange or similar pastel colors. Wear something comfy to combat the heat and the haldi that will be applied.",
              expectations: "🌼 Expect:\n\n• Tokri of flowers\n• A lot of haldi\n• Dancing and laughter and our haldi filled faces\n• Lunch to follow (from 12:00 PM)\n\nCome for the colors, stay for the music and chaos!"
            },
            {
              time: "03:00 PM",
              title: "Mayra",
              nickname: "",
              slug: "mayra",
              definition: "A sweet celebration showering the bride with blessings and joy\n\nMayra is a beautiful pre-wedding tradition where the maternal family comes together to bless the bride.\n" +
                  "With songs, rituals, gifts, and lots of happy tears, this ceremony is all about love and togetherness.\nIt's intimate, meaningful, and filled with warmth from start to finish.",
              dressCode: "Bonus points for Rajasthani attire but easy Indian traditional is a close second",
              expectations: "🌺 Expect:\n\n• Traditional Mayra rituals & blessings\n• Singing, laughter, and emotional moments\n• Gifts, sweets, and family bonding\n• Plenty of photo-worthy moments"
            },
            {
              time: "7:00 PM",
              title: "Engagement and Sangeet",
              nickname: "Rings on & Dance off",
              slug: "sagaiSangeet",
              definition: "💍 Where two hearts officially say Yes! (again 🤭). Rings first, dance floor later (Non negotiable 🕺💃🪩)\"\n\nThis special evening brings together two cherished celebrations. The engagement ceremony marks the formal union of the couple. As families exchange rings, blessings, and heartfelt wishes." +
                  "\n\nAs the evening unfolds, we segue into the Sangeet. Cue music, choreography, enthusiastic aunty perfomances and that one cousin who definitely rehearsed too much" +
                  "\n\n In short, traditions in the evening, dance floor at full throttle by nightfall",
              dressCode: "Semi-formal or Indo Western attire. Think glam, flowy and a little extra 🪩 with no set colour theme but dance friendly footwear is mandatory!",
              expectations: "💍🪩 Expect:\n\n• Ring exchange ceremony 💍\n• Family blessings 🧿\n• Countless photo sessions 📸\n• Live beats, loud cheers, and zero judgement on your dancing skills 🕺💃\n• A dinner to refuel you for more dancing  🍽️"
            }
          ]
        },
        {
          date: "Thursday, July 9, 2026",
          events: [
            {
              time: "12:00 PM",
              title: "Sajjangot",
              nickname: "Shahi Bhojan",
              slug: "sajjangot",
              definition: "🍛👑 Where royal hospitality meets serious appetite.\n\nBefore the vows, comes a feast worthy of royalty.\n\n The \"Sajjangot\" is a traditional ceremonial welcome , where guests are honored with a shahi bhojan served with warmth, abundance and massive portions of food.\n\n This is not just lunch, this is tradition, hospitality and indulgence in full form",
              dressCode: "Comfortable enough clothes to say yes to all the helpings",
              expectations: "🍲 Expect:\n\n• A grand royal style welcome\n• A lavish, multi-course shahi spread\n• A relaxed, elegant atmosphere before the wedding energy kicks in\n\nArrive hungry • Leave impressed • Definitely Overfed 😋🍛"
            },
            {
              time: "4:00 PM",
              title: "Baraat and Varmala",
              nickname: "From Baraat to Forever",
              slug: "baraatVarmala",
              definition: "💒 The loud entrance, the big moment and the sacred circle\n\n" +
                  "This is where it all comes together.\n" +
                  "The Baraat brings the energy, music, and full baraati spirit as the groom arrives in style. Once the drums fade and the cheering settles, the Varmala begins. This is the moment where we exchange sacred vows, sealing our love and commitment for eternity.",
              dressCode: "Wedding Festive | Traditional glam. \n\n• Rich sarees, classic silhouettes\n• Kurtas or traditional wedding wear\n• Comfort optional. Photos guaranteed",
              expectations: "🪷 Expect:\n\n• A high energy baraat with music, dancing and celebratory chaos\n• A beautifully adorned mandap where Varmalas are exchanged\n• Traditional wedding rituals and seven sacred pheras\n• A moment that's emotional, meaningful, and unforgettable"
            }
          ]
        }
      ]
    },

    rsvp: {
      enabled: true,
      deadline: "June 1, 2026",
      message: "Please let us know if you can join us for our special day",
      search: {
        minNameLength: 4,
        errorMessages: {
          empty: "Please enter your name to search",
          tooShort: "Please enter your full first name",
          unexpected: "We received an unexpected response. Please try again or contact us if the problem persists.",
          networkError: "We couldn't connect to our server. Please check your internet connection and try again.",
          generic: "Whoops! Something went wrong. Please try again later or contact us if the problem persists.",
          loadError: "We couldn't load your invitation. Please try again.",
          noSelection: "Please select an option before saving your RSVP.",
          noRsvpFor: "Please select who will be attending.",
          saveError: "Whoops! We couldn't save your RSVP. Please try again later or contact us if the problem persists."
        },
        successMessages: {
          day1: "✓ RSVP has been saved for Day 1",
          day2: "✓ RSVP has been saved for Day 2"
        },
        labels: {
          searchPlaceholder: "First name",
          multipleMatchesTitle: "We found multiple matches",
          multipleMatchesSubtitle: "Please select your exact name from the list below:",
          searchAgain: "Search again",
          notYou: "Not you? Search again",
          welcome: "Welcome",
          dateFlyingIn: "Date flying in",
          dateFlyingInOptional: "(Optional)",
          attending: "Attending",
          cantMakeIt: "Can't make it",
          bothOfUs: "Both of us",
          justPerson: "Just",
          neitherOfUs: "Neither of us can make it",
          saveDay1: "Save Day 1 RSVP",
          saveDay2: "Save Day 2 RSVP",
          summaryTitle: "Your RSVP Summary",
          summarySubtitle: "Thank you for your response! You can edit your RSVP below if needed.",
          edit: "Edit",
          status: "Status:",
          guests: "Guests:",
          rsvpFor: "RSVP for:",
          both: "Both"
        }
      }
    },

    registry: {
      enabled: false,
      message: "Your presence is the greatest gift, but if you'd like to honor us with a gift, we've registered at:",
      links: [
        { name: "Amazon Registry", url: "https://example.com/registry" },
        { name: "Target Registry", url: "https://example.com/registry" }
      ]
    },

    accommodations: {
      enabled: true,
      message: "We've arranged accommodations for the 8th and 9th at the same venue as our wedding",
      reservationCode: ""
    },

    exploreGoa: {
      title: "Explore Goa",
      intro: "While you're in Goa for our wedding, take some time to explore this beautiful coastal paradise!",
      sections: {
        nearby: {
          title: "Within 1 Hour Drive",
          description: "Perfect for a quick visit between events or a relaxed afternoon",
          items: [
            { name: "Colva Beach", description: "Just 5 km away, one of South Goa's longest beaches with water sports and beach shacks." },
            { name: "Benaulim Beach", description: "Right at your doorstep! A serene, less-crowded beach perfect for morning walks." },
            { name: "Varca Beach", description: "8 km away, known for its pristine white sand and peaceful atmosphere." },
            { name: "Cavelossim Beach", description: "13 km south, an upscale beach with dolphin-watching boat trips on the Sal River." },
            { name: "Goa Chitra Museum", description: "3 km away, showcasing 4,000+ artifacts of Goan agrarian life and ethnography." },
            { name: "Church of St. John the Baptist", description: "In Benaulim village, a beautiful historic church dating back to 1596." },
            { name: "Margao Market", description: "8 km away, South Goa's main market for local produce, spices, and authentic shopping." },
            { name: "Cabo de Rama Fort", description: "25 km away (45 min), a stunning clifftop fort with panoramic ocean views and historical significance." },
            { name: "Ancestral Goa (Big Foot)", description: "12 km away, an open-air museum depicting traditional Goan village life." }
          ]
        },
        moderate: {
          title: "1 to 2 Hour Drive",
          description: "Great for half-day trips and exploring further",
          items: [
            { name: "Palolem Beach", description: "40 km south (1 hour), South Goa's most famous crescent-shaped beach with kayaking and nightlife." },
            { name: "Agonda Beach", description: "35 km south (50 min), a pristine, quiet beach ideal for relaxation and turtle watching." },
            { name: "Butterfly Beach", description: "Near Palolem, accessible by boat, a secluded paradise known for butterflies and sunsets." },
            { name: "Old Goa Churches", description: "35 km north (1 hour), UNESCO World Heritage Sites including Basilica of Bom Jesus and Se Cathedral." },
            { name: "Sahakari Spice Plantation", description: "Near Ponda (40 km), guided tours through aromatic spice gardens with traditional Goan lunch." },
            { name: "Chandor Heritage Houses", description: "15 km away, magnificent Portuguese-era mansions showcasing colonial grandeur." },
            { name: "Cotigao Wildlife Sanctuary", description: "50 km south (1.5 hours), Goa's second-largest sanctuary with nature trails and treehouse viewing." }
          ]
        },
        extended: {
          title: "Over 2 Hour Drive",
          description: "Full-day adventures for the explorers",
          items: [
            { name: "Dudhsagar Falls", description: "60 km east (2+ hours), a magnificent four-tiered waterfall best visited during or after monsoon. Jeep safari and trekking available." },
            { name: "North Goa Beaches", description: "50-60 km north (1.5-2 hours), including Baga, Calangute, and Anjuna—known for vibrant nightlife, water sports, and flea markets." },
            { name: "Anjuna Flea Market", description: "55 km north (2 hours), open on Wednesdays, a bohemian market perfect for souvenirs, jewelry, and handicrafts." },
            { name: "Fort Aguada", description: "50 km north (1.5 hours), a well-preserved 17th-century Portuguese fort with lighthouse and stunning Arabian Sea views." },
            { name: "Chapora Fort", description: "60 km north (2 hours), famous from Bollywood movies, offers breathtaking views of Vagator Beach." },
            { name: "Mapusa Market", description: "45 km north (1.5 hours), Friday market with authentic Goan spices, produce, and local crafts." }
          ]
        }
      }
    },

    navigation: {
      home: "Home",
      rsvp: "RSVP",
      ourStory: "Our Story",
      events: "Events",
      schedule: "Schedule",
      travelToGoa: "Travel to Goa",
      exploreGoa: "Explore Goa"
    },

    footer: {
      credit: "created by yours truly 😉"
    }
  }
};
